export const formatEstudiante = (nombreApellido, cedulaIdentidad) => ({
  nombre: nombreApellido || 'Sin nombre',
  ci: cedulaIdentidad || 'Sin C.I.',
});

export const formatTutor = (tutor, ciTutor) => ({
  nombre: tutor || 'Sin tutor',
  ci: ciTutor || 'Sin C.I.',
});

export const formatRangoFechas = (fechaDesde, fechaHasta) => ({
  desde: fechaDesde || '-',
  hasta: fechaHasta || '-',
});

const mesesExport = ['ener', 'febr', 'marz', 'abr', 'may', 'jun', 'jul', 'agos', 'sept', 'oct', 'nov', 'dic'];
const mesesCorto = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

const parseFecha = (fecha) => {
  if (!fecha) return null;
  if (fecha instanceof Date && !isNaN(fecha.getTime())) return fecha;

  const valor = fecha.toString().trim();
  const partesSlash = valor.split('/');
  if (partesSlash.length === 3) {
    const dia = Number(partesSlash[0]);
    const mes = Number(partesSlash[1]);
    const anio = Number(partesSlash[2]);
    if (dia && mes && anio) return new Date(anio, mes - 1, dia);
  }

  const partesIso = valor.substring(0, 10).split('-');
  if (partesIso.length === 3) {
    const anio = Number(partesIso[0]);
    const mes = Number(partesIso[1]);
    const dia = Number(partesIso[2]);
    if (dia && mes && anio) return new Date(anio, mes - 1, dia);
  }

  return null;
};

export const formatFechaExport = (fecha) => {
  const date = parseFecha(fecha);
  if (!date) return fecha || '-';

  const dia = String(date.getDate()).padStart(2, '0');
  return `${dia}/${mesesExport[date.getMonth()]}/${date.getFullYear()}`;
};

export const formatFechaCorta = (fecha) => {
  const date = parseFecha(fecha);
  if (!date) return fecha || '';

  const dia = String(date.getDate()).padStart(2, '0');
  return `${dia} ${mesesCorto[date.getMonth()]} ${date.getFullYear()}`;
};

export const getEstadoVencimiento = (fechaFinVigencia) => {
  const fechaVencimiento = parseFecha(fechaFinVigencia);
  if (!fechaVencimiento) return 'sin_fecha';

  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);

  const diffTime = fechaVencimiento - hoy;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays < 0) return 'vencido';
  if (diffDays <= 30) return 'proximo_vencer';
  return 'vigente';
};

export const getTextoVencimiento = (estado) => {
  const textos = {
    vigente: 'Vigente',
    proximo_vencer: 'Proximo a vencer',
    vencido: 'Vencido',
    sin_fecha: 'Sin fecha',
  };
  return textos[estado] || 'Desconocido';
};

export const getIconoVencimiento = () => '';

export const normalizarEstadoPractica = (estado) => {
  if (!estado) return 'desconocido';

  const estadoLower = estado.toLowerCase();

  if (estadoLower.includes('aprobada por dnerhs') || estadoLower.includes('modificaciones aprobadas')) {
    return 'aprobada';
  }

  if (estadoLower.includes('pendiente') || estadoLower.includes('modificaciones pendientes')) {
    return 'pendiente';
  }

  if (estadoLower.includes('correcciones solicitadas') || estadoLower.includes('rechazad')) {
    return 'rechazada';
  }

  if (estadoLower.includes('proceso de creacion') || estadoLower.includes('proceso de creación') || estadoLower.includes('creada')) {
    return 'en_proceso';
  }

  if (estadoLower.includes('con modificaciones') && !estadoLower.includes('pendientes') && !estadoLower.includes('aprobadas')) {
    return 'modificaciones';
  }

  if (estadoLower.includes('finalizada')) {
    return 'finalizada';
  }

  if (estadoLower.includes('archivada')) {
    return 'archivada';
  }

  return 'desconocido';
};

export const getIconoEstadoPractica = () => '';

export const truncateText = (text, maxLength = 30) => {
  if (!text) return '-';
  if (text.length <= maxLength) return text;
  return `${text.substring(0, maxLength)}...`;
};

export const calcularEstadisticas = (rows) => {
  const practicasUnicas = new Set();
  const practicasRectificadas = new Set();
  const alumnosRectificados = new Set();

  rows.forEach(row => {
    if (row.cronogramaId) {
      practicasUnicas.add(row.cronogramaId);

      if (row.rectificado === true) {
        practicasRectificadas.add(row.cronogramaId);
        if (row.cedulaIdentidad) {
          alumnosRectificados.add(row.cedulaIdentidad);
        }
      }
    }
  });

  return {
    totalPracticas: practicasUnicas.size,
    practicasRectificadas: practicasRectificadas.size,
    alumnosRectificados: alumnosRectificados.size,
  };
};

export const exportToCSV = (rows, filename = 'practicas_convenio.xlsx') => {
  if (!rows || rows.length === 0) return;

  import('xlsx').then(XLSX => {
    const dataToExport = rows.map(row => ({
      "Estado": row.practicaEstado || '-',
      "Alumno": row.nombreApellido || '-',
      "C.I. Alumno": row.cedulaIdentidad || '-',
      "Cronograma": row.cronogramaId || '-',
      "Convenio": row.convenioId || '-',
      "Institucion": row.institucion || '-',
      "Carrera": row.carrera || '-',
      "Servicio": row.nombreServicio || '-',
      "Periodo": `${formatFechaExport(row.fechaDesde)} - ${formatFechaExport(row.fechaHasta)}`,
      "Fecha Inicio": formatFechaExport(row.fechaDesde),
      "Fecha Fin": formatFechaExport(row.fechaHasta),
      "Horas": row.totalHoras || 0,
      "Tutor": row.tutor || '-',
      "C.I. Tutor": row.ciTutor || '-',
      "Vencimiento Convenio": formatFechaExport(row.fechaFinVigencia),
      "Nacionalidad": row.nacionalidad || '-',
      "Curso": row.curso || '-',
      "Anio": row.anio || '-',
      "Materia": row.materia || '-',
      "Semestre": row.semestre || '-',
      "Lunes": row.lunes || '-',
      "Martes": row.martes || '-',
      "Miercoles": row.miercoles || '-',
      "Jueves": row.jueves || '-',
      "Viernes": row.viernes || '-',
      "Sabado": row.sabado || '-',
      "Domingo": row.domingo || '-',
      "Rectificado": row.rectificado ? 'Si' : 'No',
      "Fecha Inicio Rectificado": formatFechaExport(row.fechaDesdeRectificado),
      "Fecha Fin Rectificado": formatFechaExport(row.fechaHastaRectificado),
      "Observacion Rectificado": row.observacionRectificado || '-',
    }));

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Practicas Convenio");

    const fileName = filename.endsWith('.xlsx') ? filename : `Practicas_Convenio_${new Date().toISOString().split('T')[0]}.xlsx`;
    XLSX.writeFile(wb, fileName);
  }).catch(error => {
    console.error('Error al cargar XLSX:', error);
    alert('Error al exportar. Por favor, intente nuevamente.');
  });
};
